module.exports = __webpack_public_path__ + "static/img/p4.51c1fde1.png";